export function useData() {
  const options = [
    {
      label: 'Employee',
      value: 'Employee',
    },
    {
      label: 'Customer',
      value: 'Customer',
    },
    {
      label: 'Other',
      value: 'Other',
    },
    {
      label: 'No Referral',
      value: 'None',
    },
  ]

  return { options } as const
}
